import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DataUploadDialogComponent } from '../dialog/data-upload-dialog/data-upload-dialog.component';
import { AuthenticationService, UserService } from '../service';
import { User } from '../model';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Authentication } from '../model/authentication';
import { UserRequest } from '../model/user';
import { LoaderState } from 'src/app/model/loader';
import { LoaderService } from '../service/loader.service';
import { SaleReportService } from '../service/saleReport/sale-report.service';
@Component({
  selector: 'app-maincontent',
  templateUrl: './maincontent.component.html',
  styleUrls: ['./maincontent.component.css']
})
export class MaincontentComponent implements OnInit {
  openEscalationList:number;
  //notificationsCount: number; 
  private notificationsCount: any;
  private intervalId: any;
  opened = true;
  isShow = true;
  show = false;
  id:boolean;
  authenticationService: AuthenticationService;
  logoutUser: string
  private subscription: Subscription;
  currentUser: Authentication;
  userRequest: UserRequest;
  userName: String;
  menutoggle() {
    this.isShow = !this.isShow;
  }
  constructor(public dialog: MatDialog, public router: Router,
    authenticationService: AuthenticationService, private userService: UserService,
    private loaderService: LoaderService,private saleReportService: SaleReportService) {
    this.authenticationService = authenticationService;
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DataUploadDialogComponent, {
      width: '90vh',
      height: '40vh',
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }
  onLoggedout() {
    this.authenticationService.logout();
    
    this.router.navigate(['/login']);
  }
  public refreshCurrentUser() {
    this.userService.findUser(localStorage.getItem("email")).subscribe(data => {
      this.userRequest = data;
      this.userName = this.userRequest.firstName + " " + this.userRequest.lastName;
      if(this.userRequest.role.roleName=="ADMIN"){
        this.id=true;
      }
      else{
        this.id=false;
      }
      localStorage.setItem("roleName", this.userRequest.role.roleName);
      localStorage.setItem("userId", this.userRequest.id.toString());
      localStorage.setItem("roleId", this.userRequest.role.id.toString())
    });
  }
  ngOnInit() {
    this.refreshCurrentUser();
    this.subscription = this.loaderService.loaderState
      .subscribe((state: LoaderState) => {
        this.show = state.show;
      });
    this.startScheduler(60000);
  }
  resetNotifications(): void {  
   // this.router.navigate(['/admin/open-escalation']);
  }
  startScheduler(interval: number) {
    this.stopScheduler(); // Ensure any existing scheduler is stopped
    this.intervalId = setInterval(() => {   
      // this.resetNotifications();
      this.notificationsCount = 0;
      this.saleReportService.getOpenEscalationReport(localStorage.getItem('email')).subscribe(data => {
        this.notificationsCount=data.length;
      });
    }, interval);
  }

  stopScheduler() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}
